import React, { Component } from 'react';
import Display3D from './components/Display3D';
import Instructions from './components/Instructions';
import LoadWidget from './components/LoadWidget';
import { Process, Task, Instruction } from './logic/Tasks';
import Menu from './components/Menu';
import './App.scss';

const updateDisplaySettings = ( keys, vals ) => { document.dispatchEvent( new CustomEvent( "updateDisplaySettings", { detail: { keys: keys, values: vals } } ) ); return true }

const Processes = [
    new Process( "Setup", [

        new Task( "Master Power", "Before you can turn everything on, we need power", [

            new Instruction( "Master Power at Wall - On", "Master Power Switch" ),

        ] ),
        new Task( "Liquid Cooling", "", [

            new Instruction( "Water Chiller - On", "Water Chiller Power" ),
            new Instruction( "Water Chiller - Turn on Display", "Water Chiller Display" ),
            new Instruction( "Galden Chiller - On", "Galden Chiller Power" ),

        ] ),
        new Task( "Turning the PC on", "The Computer is controlled by the NMR machine", [

            new Instruction( "Press the 'PC' button on the NMR Control Tower", "PC", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.boot(); return true } )

        ] ),

        new Task( "Open Software", "Once the PC has booted up, you can start the software", [

            new Instruction( "Click 'AcqNmrV95'", "SoftwareStart" )
        ] ),

        new Task( "Controlling the Magnet", "The software directly controls the magnet", [

            new Instruction( "Go to the Hardware menu", "Hardware" ),
            new Instruction( "Go to Magnet", "Magnet" ),
            new Instruction( "Click Switch On", "Switch On" ),
            new Instruction( "Press the 'TX' button on the NMR Control Tower", "TX" )

        ] ),

        new Task( "Heat and Airflow", "The magnet is air-cooled, so the air needs turning on", [

            new Instruction( "Air Tap - On", "Air Flow Valve" ),
            new Instruction( "Heater - On", "NMR Heater Power", scn => { scn.getObjectByName( "HeaterScreenAnchor STATIC" ).ReactData.setDisplay( "VTC91" ); return true } ),

        ] ),

        new Task( "Configuring the Thermostat", "The software will eventually control the temperature of the magnet, but first, the thermostat needs setting via the keypad", [

            new Instruction( "Press Reset", "keypad_reset" ),
            new Instruction( "Press 1", "keypad_1" ),
            new Instruction( "Press Enter", "keypad_enter", scn => { setTimeout( () => scn.getObjectByName( "HeaterScreenAnchor STATIC" ).ReactData.setDisplay( "FLOW?" ), 1500 ); return true } ),
            new Instruction( "Press Enter when 'Flow' shows", "keypad_enter" ),

        ] ),
        new Task( "Setting the Temperature", "This is where you would input your required temperature. However, for this demo, we'll just use 25 degrees", [

            new Instruction( "Input 25 and press enter ( press reset to clear value )", "keypad_enter", () => document.querySelector( ".heater-display" ).innerHTML === "25" ),

        ] ),

        new Task( "Syncing the Software", "Now that the heater is on and set, we can connect the PC. In the future, you will set the temperature of the sample by right clicking VTC and choosing 'Set Point'.", [

            new Instruction( "Right click the VTC section in the top right", "heater_controls" ),
            new Instruction( "Click Connect", "Connect", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setState( { VTCConnected: true } ); return true } ),

        ] ),

        new Task( "Sample Insertion", "We're now ready to place your sample in the NMR, but you need to ensure your sample is in the field", [

            new Instruction( "Centre your sample in the device, ensuring the line aligns with the middle of your material", "Sample Holder" ),
            new Instruction( "Insert sample into NMR", "Sample Entry" ),
            new Instruction( "Apply weight to stop it from moving", "Sample Weight" ),

        ] ),

        new Task( "Datafile Location", "Back in the software, your file is saved to the hard-drive for analysis at a later point", [

            new Instruction( "Under the Main par tab, choose a File Location (just click the table cell for this demo)", "Data Acquisition File", () => updateDisplaySettings( [ "Data Acquisition File" ], [ "FilePath" ] ) ),

        ] ),

        new Task( "Setting Up", "The first experiment will be a 'simple Non-Polarised sequence', NP. The Recycle Delay and Delay Tau need to be ~5x your Relaxation Time, T1. For now, we will guess a T1 of 0.2, but this will be refined later on", [

            new Instruction( "Set Experiment To NP", "Experiment", ( scn, clicked ) => clicked.value === "NP" ),
            new Instruction( "Set Recycle Delay To 1", "Recycle Delay", ( scn, clicked ) => clicked.value === "1" ),
            new Instruction( "Set Delay Tau To 1", "Delay Tau", ( scn, clicked ) => clicked.value === "1" ),
            new Instruction( "Set Relaxation Field To 7", "Relaxation field", ( scn, clicked ) => clicked.value === "7" ),

        ] ),

        new Task( "Go Time", "Now that the initial values are all set, it's time to do a run and check our guess of T1", [

            new Instruction( "Press the Gun to run", "Gun", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setGraph( "F1Output" ); return true } ),

        ] ),

        new Task( "Save and repeat", "The software can now set the Observe Offset. Using the 'Correct' buttons on the toolbar at the top quickly sets values in the Main and Acquisition parameters from the evaluated data, meaning we don't have to.", [

            new Instruction( "Save", "Save" ),
            new Instruction( "Click 'Correct F1'", "CorrectF1", () => updateDisplaySettings( [ "Observe Offset" ], [ "9000" ] ) ),

        ] ),

        new Task( "Set up for Final Calibration", "We are now going to determine T1 at 7MHz", [

            new Instruction( "Set Experiment To NP/S", "Experiment", ( scn, clicked ) => clicked.value === "NP/S" ),
            new Instruction( "Go to Acq. par", "Acq. par" ),
            new Instruction( "Go to Conf", "Conf" ),
            new Instruction( "Ensure the Pulse Width (PW90) is 5", "90deg pulse [us]", ( scn, clicked ) => clicked.value === "5" ),
            new Instruction( "Go to Main par", "Main par" ),
            new Instruction( "Set Maximum T1 to be your previous guess of 0.2", "Maximum T1", ( scn, clicked ) => clicked.value === "0.2" ),
            new Instruction( "Set Recycle Delay to 5 times your T1", "Recycle Delay", ( scn, clicked ) => clicked.value === "1" ),
            new Instruction( "Reset Relaxation Field to 7", "Relaxation field", ( scn, clicked ) => clicked.value === "7" ),
            new Instruction( "Press the Gun to run", "Gun", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setGraph( "NPSBadPreEval" ); return true } )

        ] ),

        new Task( "Analyse graph", "It's hard to tell if the data is any good until we run an Evaluation Procedure on it", [

            new Instruction( "Go to the Evaluation Dialog", "Eval" ),
            new Instruction( "Set the Evaluation Procedure to 'RAM'", "EvaluationProcedure", ( scn, clicked ) => clicked.value === "RAM Relax.rate using WAM" ),
            new Instruction( "Click Execute to run the procedure", "EvalExecute", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setGraph( "NPSBadPostEval" ); updateDisplaySettings( [ "Data file", "Data zone", "Relaxation field", "T1 [s]", "R=1/T1 [1/sec]", "R Error [+/-]", "R Error [%]" ], [ "FilePath", "4", "6.999", "0.038", "26.2", "0.241", "0.922" ] ); return true } )

        ] ),

        new Task( "Check output", "This graph is not ideal. We have the exponential shape, but, ideally, we should just be capturing the initial sharp increase. It's obvious here we have a large tail of flat data here.", [

            new Instruction( "Go to Evaluation", "Evaluation" ),

        ] ),

        new Task( "Observations", "Looking at the output on the left, you can see the error for the Maximum T1 ( R Error [%] ) is large. To gather a better result, we need to run a second NP/S experiment with a smaller value of T1.", [

            new Instruction( "Click 'Correct T1MX'", "CorrectT1MX", () => updateDisplaySettings( [ "Maximum T1" ], [ "0.038" ] ) ),
            new Instruction( "Go to Main par", "Main par" ),
            new Instruction( "Set Recycle Delay to 5 times the new value of Maximum T1", "Recycle Delay", ( scn, clicked ) => clicked.value === "0.19" ),
            new Instruction( "Press the Gun to run", "Gun", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setGraph( "NPSGoodPreEval" ); return true } ),

        ] ),

        new Task( "Analyse graph", "", [

            new Instruction( "Go to the Evaluation Dialog", "Eval" ),
            new Instruction( "Set the Evaluation Procedure to 'RAM'", "EvaluationProcedure", ( scn, clicked ) => clicked.value === "RAM Relax.rate using WAM" ),
            new Instruction( "Click Execute to run the procedure", "EvalExecute", scene => { scene.getObjectByName( "ScreenAnchor STATIC" ).ReactData.setGraph( "NPSGoodPostEval" ); updateDisplaySettings( [ "Data file", "Data zone", "Relaxation field", "T1 [s]", "R=1/T1 [1/sec]", "R Error [+/-]", "R Error [%]" ], [ "FilePath", "4", "6.999", "0.03678", "27.19", "0.173", "0.6367" ] ); return true } )

        ] ),

        new Task( "Check output", "This graph looks much better, but we can check the error again", [

            new Instruction( "Go to Evaluation", "Evaluation" ),

        ] ),

        new Task( "That's better!", "You can see the error is greatly reduced, and you can take this value of T1 to be correct within the error", [

            new Instruction( "Click Correct T1MX", "CorrectT1MX", () => updateDisplaySettings( [ "Maximum T1" ], [ "0.03678" ] ) )

        ] ),

        new Task( "That's Everything!", "The FFC NMR is now all set up and ready to go. We have determined the Relaxation Time for your sample at 7MHz, and now we can use this to determine T1 at other frequencies.", [

            new Instruction( "Return to the Main Menu", "" )

        ] )

    ] ),
    new Process( "Running an Experiment", [

        new Task( "To the Computer", "At this point, everything should be on and ready to go, so we can move straight to the Software", [

            new Instruction( "Click the Computer", "Computer" )

        ] ),

        new Task( "Go to the Profile Wizard", "", [

            new Instruction( "Go to Actions", "Actions" ),
            new Instruction( "Click Profile Wizard", "Profile Wizard" )

        ] ),

        new Task( "Synchronise Parameters", "We can use our calibrated values to quickly populate the majority of the fields on the right", [

            new Instruction( "Click 'Synchronize with Acq Parameters'", "SyncParams", () => {

                [ [ "Initial T1MX", "0.03678" ] ].forEach( val => document.getElementById( val[ 0 ] ).value = val[ 1 ] );
                return true

            } )

        ] ),

        new Task( "Choosing a Data file", "We use the same data file used for calibration, and export to the same location", [

            new Instruction( "Click 'Change' under Data File to set the file used before", "Data File", ( scene, clicked ) => { clicked.previousSibling.value = "FilePath"; document.getElementById( 'Export File' ).previousSibling.value = "FilePath"; return true } ),

        ] ),

        new Task( "Running the Scan", "The default settings are all we need to move forward", [

            new Instruction( "Click Execute", "WizardExecute", () => document.dispatchEvent( new CustomEvent( "setWindow", { detail: "DataReasonable" } ) ) )

        ] ),

        new Task( "Go On", "The software will give you the found values compared to the initial ones you provided. If there is a large discrepency, then you did not calibrate correctly and will need to start over. Ideally, it should tell you to proceed", [

            new Instruction( "Click Go On", "DataReasonableGoOn", () => document.dispatchEvent( new CustomEvent( "setWindow", { detail: "NumRuns" } ) ) )

        ] ),

        new Task( "Number of Runs", "You will then be asked how many runs to perform. Leaving it at the default of 1 is fine", [

            new Instruction( "Click OK to continue", "NumRunsOK" )

        ] ),

        new Task( "Done", "Your data will be output in two files to the location you specified earlier. The file you want is the smaller of the two; the larger is just raw data.", [

            new Instruction( "Return to the Main Menu", "" )

        ] )

    ], [ "Screen", "Master Power Switch", "Water Chiller Power", "Water Chiller Display", "Galden Chiller Power", "NMR Heater Power", "Air Flow Valve", "PC", "TX", "Sample Entry", "Sample Weight" ] )

]

class App extends Component {

    constructor( props ) {

        super( props )
        this.state = { atMenu: true, scene: null, activeProcess: 0, loaded: false, tutorialDone: false };

    }

    setLoaded = loaded => {
        this.setState( { loaded: loaded } );
    }

    setProcess = newProcess => {

        document.dispatchEvent( new CustomEvent( "Reset" ) );
        Processes[ newProcess ].initialState && document.dispatchEvent( new CustomEvent( "init", { detail: Processes[ newProcess ].initialState || null } ) );
        this.setState( { activeProcess: newProcess } );

    }

    updateScene = scene => {

        this.setState( { scene: scene } );

    }

    toggleMenu() {

        const elsToShow = Array.from( document.getElementsByClassName( "hidden" ) );
        Array.from( document.getElementsByClassName( "visible" ) ).forEach( el => { el.classList.remove( "visible" ); el.classList.add( "hidden" ) } );
        elsToShow.forEach( el => { el.classList.remove( "hidden" ); el.classList.add( "visible" ) } );

    }

    toggleTutorial = () => {
        this.setState( { tutorialDone: !this.state.tutorialDone } );
    }

    render() {

        return (
            <React.Fragment>
                <div className="App">
                    <div className="mainframe hidden">
                        <Display3D updateLoaded={ this.setLoaded } updateScene={ this.updateScene } />
                        <Instructions toggleMenu={ this.toggleMenu } scene={ this.state.scene } Process={ Processes[ this.state.activeProcess ] } />
                        <button id="help" onClick={ this.toggleTutorial }>?</button>
                        { this.state.loaded && !this.state.tutorialDone ? <Tutorial done={ () => this.setState( { tutorialDone: true } ) } /> : null }
                    </div>
                    <Menu isVisible={ true } disabled={ this.state.loaded ? false : true } toggleMenu={ this.toggleMenu } setProcess={ this.setProcess } text={ { "Header": "Using the Stelar FFC NMR", "Type": "menu", "Items": Processes } } />
                </div>
                { this.state.loaded ? null : <LoadWidget /> }
            </React.Fragment>
        );

    }
}

class Tutorial extends React.Component {
    constructor( props ) {
        super( props );
        this.state = { stage: 0, targetFrame: false };
        this.frames = [
            { el: ".Instructions", text: "This panel will guide you through the demonstration.\nYour task and any extra info can be found here.", anchor: "left" },
            { el: ".taskList", text: "Here are the steps you currently need to complete.\nHovering over one will highlight where you need to go.", anchor: "left" },
            { el: ".Display", text: "You can interact with the scene simply by clicking.\nHovering an object will tell you its name, and clicking one of the larger machines will take you in closer.\nYou can click and drag to move the camera around.", anchor: "right" },
            { el: "#help", text: "If you ever get stuck, just click here to see this help again", anchor: "left" }
        ]

    }

    nextStage = ev => {

        console.log( ev.nativeEvent )
        if ( this.state.stage < this.frames.length - 1 ) {
            this.setState( { stage: this.state.stage + 1, targetFrame: document.querySelector( this.frames[ this.state.stage + 1 ].el ).getBoundingClientRect() } );
        } else {
            this.props.done();
            this.setState( { stage: 0 } );
        }

    }

    calculateFrames = () => {
        this.setState( { targetFrame: document.querySelector( this.frames[ this.state.stage ].el ).getBoundingClientRect() } );
    }

    componentDidMount() {
        this.calculateFrames();
        window.addEventListener( "resize", this.calculateFrames );
    }

    componentWillUnmount() {
        window.removeEventListener( "resize", this.calculateFrames );
    }

    render() {

        const frame = this.frames[ this.state.stage ];
        const frameEl = this.state.targetFrame || document.querySelector( this.frames[ this.state.stage ].el ).getBoundingClientRect();

        return (
            <div className="component-tutorial" onClick={ this.nextStage }>
                <div className="tutorialFrame" style={ { clipPath: `polygon(0% 0%, 0% 100%, ${ frameEl.left }px 100%, ${ frameEl.left }px ${ frameEl.top }px, ${ frameEl.right }px ${ frameEl.top }px, ${ frameEl.right }px ${ frameEl.bottom }px, ${ frameEl.left }px ${ frameEl.bottom }px, ${ frameEl.left }px 100%, 100% 100%, 100% 0%)` } }></div>
                <p className="tutorialText" style={ { left: frameEl[ frame.anchor ] + ( frame.anchor === "left" ? -400 : 0 ), top: frameEl.top, textAlign: ( frame.anchor === "left" ? "right" : "left" ) } }>{ frame.text + "\n\nCLICK to Continue..." }</p>
            </div>
        )
    }
}


export default App;
